import { max, min } from 'd3-array';
import { bandAxis, linearAxis } from '../../../factory/axes';

import data from './data/data.json';

export default function (props) {
  const { initialWidth } = props;

  const margins = {
	    top: 0,
	    right: 25,
	    bottom: 40,
	    left: 100,
  };

  const barHeight = 20;
  const padding = 0.15;
  const keyDomain = data.map(d => d.label);

  const width = initialWidth - margins.right - margins.left;
  const height = keyDomain.length * (barHeight + (padding * barHeight));

  const maxValue = max(data, d => d.amt);
  const minValue = min(data, d => d.amt);

  const xAxisConfig = {
    orientation: 'bottom',
    domain: [0, 100],
    range: [0, width],
    nice: true,
  };

  const yAxisConfig = {
    orientation: 'left',
    domain: keyDomain,
    range: [0, height],
    padding,
  };

  const { axis: xAxis, scale: x } = linearAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = bandAxis(yAxisConfig);

  return {
    data,
    height,
    margins,
    initialHeight: height + margins.top + margins.bottom,
    initialWidth,
    width,
    x,
    xAxis,
    y,
    yAxis,
  };
}
